import React from "react";
import SingleGroup from "./SingleGroup";
function ModiferGroups({
  selectedItem,
  setItemSection,
  itemSection,
  singleItem,
  setSingleItem,
  isStoreSelected,
  isNewUI,
  disable,
}) {
  return (
    <>
      {selectedItem?.itemInfo?.modifierGroups?.map((modifierGroup) => (
        <SingleGroup
          isStoreSelected={isStoreSelected}
          key={modifierGroup?.modifierGroupId?._id}
          {...{
            singleItem,
            setSingleItem,
          }}
          setModifierGroups={setItemSection}
          selectedModifierGroups={itemSection}
          modifierGroup={modifierGroup?.modifierGroupId}
          isNewUI={isNewUI}
          disable={disable}
          actualItemPrice={selectedItem?.itemInfo?.price ?? 0}
        />
      ))}
    </>
  );
}

export default ModiferGroups;
